export {
  Accordion,
  AccordionItem,
  AccordionTab,
  type AccordionMixedItem,
  type AccordionProps,
  type AccordionItemProps,
  type AccordionTabProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Accordion';
